export default {
  columns: {
    name: "Name",
    createdOn: "Created on",
    updatedOn: "Last update",
    status: "Status",

    // Dossier
    subject: "Subject",
    type: "Type",
    from: "From",

    // Person
    firstName: "First name",
    lastName: "Surname",
    lastNameAffix: "Surname affix",

    // Invoice
    invoiceNumber: "#",
    invoiceDate: "Invoice date",
    invoiceDueDate: "Due date",

    // Company contact
    emailAddress: "Email address",
    phoneNumber: "Phone number",
    function: "Function",
  },
  order: {
    asc: "Ascending",
    desc: "Descending",
  },

  paginate: {
    total: "Total",
    pages: "Pages",
  },
}
